import { HotjarRouterInitializer, NgxHotjarService } from '@foxeet/hotjar';
import { ComponentRef } from '@angular/core';

export function HotjarCookiesConsent(hjService: NgxHotjarService) {
  const cookiesConsent = localStorage.getItem('haveAcceptedCookies');
  return cookiesConsent && JSON.parse(cookiesConsent) ? HotjarRouterInitializer(hjService) : async (c: ComponentRef<any>) => {};
}
